export default "__VITE_ASSET__DWTibuN1__"